// extracted by mini-css-extract-plugin
export default {"main":"similarOffers_main__lw41Q","showMoreBtn":"similarOffers_showMoreBtn__wSPIH","emptyState":"similarOffers_emptyState__Nt4ag"};